import { ValidationItems } from '@kanda-libs/ks-component-ts';

export const REQUEST_CHANGES_MODAL_ID = 'request-quote-changes-modal';

export const REQUEST_VALIDATION: ValidationItems = {
  required: { value: true, message: 'Please provide a change request.' },
};
